import React from 'react'
import TextareaAutosize from 'react-autosize-textarea'
import PropTypes from 'prop-types'

class CappedTextArea extends React.Component {
  constructor (props) {
    super(props)

    this.handleOnChange = this.handleOnChange.bind(this)
  }

  handleOnChange (e) {
    if (e.target.value.length <= 500) {
      this.props.onChange(e)
    }
  }

  render () {
    const characterCount = this.props.value ? this.props.value.length : 0

    return (
      <React.Fragment>
        <TextareaAutosize {...this.props} onChange={this.handleOnChange} />
        <div
          style={{
            textAlign: 'right'
          }}
        >
          <span>{characterCount}</span> / <span>{this.props.limit}</span>
        </div>
      </React.Fragment>
    )
  }
}

CappedTextArea.propTypes = {
  limit: PropTypes.number,
  value: PropTypes.string,
  onChange: PropTypes.func
}

export default CappedTextArea
